module.exports = __webpack_public_path__ + "img/6.651dbe45.png";